import { render } from "./HelixRadioButtons.vue?vue&type=template&id=380e20a6"
import script from "./HelixRadioButtons.vue?vue&type=script&lang=js"
export * from "./HelixRadioButtons.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__